export default __webpack_public_path__ + "assets/images/emprestimoe07e9d5c8db5e598cb2e36e73a0bb8a4.png";